export const MODAL_IS_OPEN = 'PAGE/MODAL_IS_OPEN'
export const HELPER_GET_INFO = 'PAGE/HELPER_GET_INFO'